export type PictureTextType = "Grid" | "Slider" | "unknown";

export const TRACKING_PROMO_TYPE = "ImagePromotion";